<template>
  <alzata-dialog ref="modal" :title="'Assign a Dog'">
    <div class="row g-2">
      <div class="col-12">
        <label for="dog" class="small">Select a dog</label>
        <select class="form-select" v-model="selectedDog">
          <option value="">Select a dog</option>
          <option v-for="dog in dogs" :value="dog.id">
            {{ dog.name }}
          </option>
        </select>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="this.$refs.modal.hide">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="saveDogAssignment">
        Save
      </button>
    </template>
  </alzata-dialog>
</template>

<script>
import { getJson, postJson } from "../apis/baseApiClient";
export default {
  name: "AssignDogDialog",
  emits: ["saveDogAssignment"],
  mounted() {
    (async () => {
      const dogs = await getJson("/api/v1/dogs?$orderby=Name%20desc");

      this.dogs = dogs;
    })();
  },
  data() {
    return {
      dogs: null,
      userId: null,
      selectedDog: null,
    };
  },
  methods: {
    show(veteran) {
      this.userId = veteran.userId;
      this.selectedDog = veteran.dogId;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    saveDogAssignment() {
      this.$emit("saveDogAssignment", {
        userId: this.userId,
        dogId: this.selectedDog,
      });
    },
  },
};
</script>
